angular.module('aprima-utils', ['lodash']);
